import { createAppTRPC, createTRPCLinks } from '@xhubio-saas/core-frontend/kernel'
import type { AppRouter } from '@xhubio-saas/saas-pdf-api-backend/trpc'

/**
 * Typed tRPC React client bound to the app-backend AppRouter.
 *
 * Replaces the previously untyped `trpc` from
 * `@xhubio-saas/core-frontend/kernel` (which is `: any` for backward
 * compatibility). New code should import from this file.
 */
export const trpc = createAppTRPC<AppRouter>()

/** Standard transport links — apps wire trpc.createClient with these. */
export const trpcLinks = createTRPCLinks
